/**
 * Deep link to the emissions map on the reporting page.
 *
 * Its own module so the Overview can link to the map without importing
 * CpiReports — a route-sized component that pulls in every chart on the page.
 *
 * The sub-tab travels with the fragment even though the map now sits on the
 * default tab. Being explicit keeps the link correct if the map moves again, and
 * costs nothing — a bare fragment pointing at an element on another tab is
 * exactly how this broke the first time.
 */
export const EMISSIONS_MAP_ANCHOR = 'emissions-map';

/** The sub-tab the map is rendered under — directly below the emissions matrix. */
export const EMISSIONS_MAP_SUBTAB = 'emissions';

export const EMISSIONS_MAP_LINK =
  `/cpi-reports?subtab=${EMISSIONS_MAP_SUBTAB}#${EMISSIONS_MAP_ANCHOR}`;
